<div class="dash-content">
  <div class="grid">

    <!-- ─── CARD SYSTEM ──────────────────────────── -->
    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">Card System</div>
          <div class="dash-sub">Estructura base: <code>.card &gt; .card-header + .card-body</code></div>
        </div>
      </div>
    </div>

    <div class="col-12 dash-card">
      <div class="dash-header">
        <div>
          <div class="dash-title">Título</div>
          <div class="dash-sub">Subtítulo del card</div>
        </div>
      </div>
      <div class="dash-body">
        <span class="dash-sub">Contenido del card</span>
      </div>
    </div>

    <!-- ─── PILLS ────────────────────────────────── -->
    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">Pills</div>
          <div class="dash-sub">Clase <code>.pill</code> — usada en card-header para etiquetas y estados</div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="dash-card">
        <div class="dash-header">
          <div>
            <div class="dash-title">Ejemplo con pills</div>
            <div class="dash-sub">Subtítulo del card</div>
          </div>
          <div class="dash-pills">
            <span class="dash-pill">Actualiza cada 60s</span>
          <span class="dash-pill">Vista Director de Rentas</span>
          </div>
        </div>
        <div class="dash-body">
          <span class="dash-sub">Las pills van siempre en el lado derecho del <code>.card-header</code></span>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">Card Row — Flex</div>
          <div class="dash-sub">.flex .flex-wrap .gap-3 — cada card con .flex-1 + min-width</div>
        </div>
      </div>
      <div class="flex flex-wrap gap-3">
        <div class="dash-card flex-1" style="margin:0;min-height:60px;min-width:180px">
          <div class="dash-body"><span class="dash-title">$55M</span>
            <div class="dash-sub">Titulo 1</div>
          </div>
        </div>
        <div class="dash-card flex-1" style="margin:0;min-height:60px;min-width:180px">
          <div class="dash-body"><span class="dash-title">$28M</span>
            <div class="dash-sub">Titulo 2</div>
          </div>
        </div>
        <div class="dash-card flex-1" style="margin:0;min-height:60px;min-width:180px">
          <div class="dash-body"><span class="dash-title">$54M</span>
            <div class="dash-sub">Titulo 3</div>
          </div>
        </div>
        <div class="dash-card flex-1" style="margin:0;min-height:60px;min-width:180px">
          <div class="dash-body"><span class="dash-title">$67M</span>
            <div class="dash-sub">Titulo 4</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="dash-header">
        <div>
          <div class="dash-title">Card Row — Grid</div>
          <div class="dash-sub">.grid .col-12 .sm:col-6 .md:col-3 (responsive)</div>
        </div>
      </div>
      <div class="grid">
        <div class="col-12 sm:col-6 md:col-3">
          <div class="dash-card" style="margin:0;min-height:60px">
            <div class="dash-body"><span class="dash-title">$55M</span>
              <div class="dash-sub">Titulo 1</div>
            </div>
          </div>
        </div>
        <div class="col-12 sm:col-6 md:col-3">
          <div class="dash-card" style="margin:0;min-height:60px">
            <div class="dash-body"><span class="dash-title">$28M</span>
              <div class="dash-sub">Titulo 2</div>
            </div>
          </div>
        </div>
        <div class="col-12 sm:col-6 md:col-3">
          <div class="dash-card" style="margin:0;min-height:60px">
            <div class="dash-body"><span class="dash-title">$54M</span>
              <div class="dash-sub">Titulo 3</div>
            </div>
          </div>
        </div>
        <div class="col-12 sm:col-6 md:col-3">
          <div class="dash-card" style="margin:0;min-height:60px">
            <div class="dash-body"><span class="dash-title">$67M</span>
              <div class="dash-sub">Titulo 4</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ─── KPI ICONS ──────────────────────────────── -->
    <div class="col-12">
      <div class="dash-header" style="margin-bottom:8px">
        <div>
          <div class="dash-title">KPI Icons</div>
          <div class="dash-sub">SVG en <code>assets/img/dashboard/</code></div>
        </div>
      </div>
    </div>

    <div class="col-12 dash-card">
      <div class="dash-body">
        <div class="flex flex-wrap gap-3">
          <div class="css-uikit-icon-item flex-1" style="min-width:180px" *ngFor="let icon of icons">
            <img [src]="'assets/img/dashboard/' + icon + '.svg'" [alt]="icon" />
            <code>{{ icon }}</code>
          </div>
        </div>
      </div>
    </div>

    <!-- ─── COLOR PALETTE ─────────────────────────── -->
    <div class="col-12">
      <div class="dash-header" style="margin-bottom:8px">
        <div>
          <div class="dash-title">Color Palette</div>
        </div>
      </div>
    </div>


    <div class="col-12 dash-card">
      <div class="dash-body">
        <ng-container *ngFor="let group of paletteGroups">
          <div class="col-12">
            <div class="dash-header" style="margin-bottom:8px">
              <div>
                <div class="dash-title">{{ group.group }}</div>
                <div class="dash-sub" *ngIf="group.group === 'Paleta heredada'">Tokens legacy — usar solo para compatibilidad
                  con
                  estilos existentes</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="css-uikit-swatch-grid">
              <div class="css-uikit-swatch" *ngFor="let s of group.items">
                <div class="css-uikit-swatch-color" [ngClass]="s.previewBg || (s.isClass ? s.name : null)"
                  [style.background]="!s.isClass ? ('var(' + s.name + ')') : null"></div>
                <code>{{ s.isClass ? '.' + s.name : s.name }}</code>
                <span class="dash-sub">{{ s.desc }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

  </div>
</div>